import type { StoreApi, State } from '../types';

export const setEcosystem =
	(ecosystem: Omit<State, 'issueKey'>, issueKey: string) =>
	({ setState }: StoreApi) => {
		if (ecosystem) setState({ ...ecosystem, issueKey });
	};
